import { Component, input } from '@angular/core';
import { SearchFieldComponent } from '../forms/search-field/search-field.component';
import { SelectOption } from '../../../_interfaces/select-field.interface';

@Component({
  selector: 'app-table-header-template',
  imports: [SearchFieldComponent],
  template: `
    <div class="row align-items-center mb-3 mb-md-4 gy-2">
      @if (!hideFilter()) {
        <div class="col-auto pe-0">
          <ng-content select="[filter]"></ng-content>
        </div>
      }
      @if (searchOptions().length) {
        <div class="col">
          <app-search-field [searchOptions]="searchOptions()"></app-search-field>
        </div>
      }
      <div class="col-auto ms-auto">
        <ng-content select="[buttons]"></ng-content>
      </div>
    </div>
  `,
})
export class TableHeaderTemplateComponent {
  hideFilter = input<boolean>(false);
  searchOptions = input<SelectOption[]>([]);
}
